<template>
  <module-card
    v-bind="params"
    :permissions="permissions"
    :loading="loading"
    :description="lastUpdateMessage"
    :retryFunction="retryFunction"
    :segmentations="segmentations"
    @visibleChanged="$emit('visibleChanged', $event)"
  >
    <template slot="content">
      <iframe
        scrolling="no"
        class="build-progress-iframe"
        :src="iframeUrl"
        :style="canIframeInteractStyle"
      />
    </template>
    <template slot="actions">
      <v-btn
        class="slin-btn"
        @click="$router.push({ name: 'constructionProgress' })"
        :style="{ color: params.themeColor }"
      >
        <i class="bexsicon-construction-sm" />
        Ver evolução
      </v-btn>
    </template>
  </module-card>
</template>

<script>
import ModuleCard from '@/components/layout/Card';
import {
  PROFILES,
  IFRAME,
  SEGMENTATIONS,
  UNIT,
  DOCS
} from '../../utils/constants';
import axios from 'axios';
export default {
  components: {
    ModuleCard
  },
  computed: {
    lastUpdateMessage() {
      return this.lastUpdate
        ? `Última atualização em ${new Date(this.lastUpdate).toLocaleDateString(
            'pt-BR'
          )}`
        : this.params.description;
    },
    canIframeInteractStyle() {
      return {
        pointerEvents: this.$store.getters[IFRAME.GET_INTERACTION]
          ? 'all'
          : 'none'
      };
    },
    segmentations() {
      const product = this.$store.getters[UNIT.GET_SELECTED_PRODUCT];
      const productDetails = this.$store.getters[
        UNIT.GET_SELECTED_PRODUCT_DETAILS
      ];

      const hasOwnerDocs = this.$store.getters[DOCS.HAS_OWNER_DOCS];
      const isIndirect = this.$store.getters[UNIT.GET_IS_INDIRECT];

      if (isIndirect && hasOwnerDocs) {
        return null;
      } else {
        return [
          SEGMENTATIONS.ASSOCIATIVE__REHEARSE_STATUS,
          SEGMENTATIONS.ASSOCIATIVE_REHEARSED__REHEARSE_STATUS,
          SEGMENTATIONS.SFH__REHEARSE_STATUS,
          SEGMENTATIONS.SETTLED__REHEARSE_STATUS,
          SEGMENTATIONS.INDIRECT__USER_ROLE,
          SEGMENTATIONS.DIRECT__REHEARSE_STATUS,
          SEGMENTATIONS.IN_CONSTRUCTION__CONSTRUCTION_STAGE
        ];
      }
    }
  },
  data() {
    return {
      permissions: [
        PROFILES.ADMIN_PROFILE,
        PROFILES.ADMIN_BEXS_PROFILE,
        PROFILES.ADMIN_HR_PROFILE,
        PROFILES.HR_PROFILE
      ],
      iframeError: false
    };
  },
  props: {
    iframeUrl: {
      type: String,
      required: true
    },
    tourUrl: {
      type: String,
      default: ''
    },
    lastUpdate: String,
    stage: String,
    loading: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      required: true
    },
    retryFunction: Function
  },
  created() {
    this.getIframeStatus();
  },
  methods: {
    goToTour() {
      window.open(this.tourUrl, '_blank');
    },
    async getIframeStatus() {
      this.iframeError = !(await axios.head(this.iframeUrl).catch(err => {
        console.error(err.message);
      }));
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/breakpoint';

>>> .v-card__text {
  padding-top: 0;
}

>>> iframe {
  overflow: hidden;
}

.build-progress-iframe {
  border: none;
  width: 100%;
  margin-top: -2%;

  @include breakpoint(mobile) {
    margin-top: -7%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/ConstructionCard.vue